import React from 'react';
import { Button } from 'react-bootstrap';
import { useLocation } from 'react-router-dom';
import { useAppContext } from 'providers/AppProvider';

const ToggleButton = () => {
  const {
    config: { isNavbarVerticalCollapsed, checkorg },
    setConfig
  } = useAppContext();
  
  const { pathname } = useLocation();
  
  // SA 경로에서 사이트 토큰 없을 때 햄버거 버튼 숨김 로직
  const isSAPath = pathname.startsWith('/safedb/SA/');
  const siteToken = sessionStorage.getItem('siteToken');
  const shouldHideBurgerMenu = isSAPath && !siteToken;
  

  const handleClick = () => {
    if (checkorg) {
      document
        .getElementsByTagName('html')[0]
        .classList.toggle('navbar-vertical-collapsed');
      setConfig('isNavbarVerticalCollapsed', !isNavbarVerticalCollapsed);
    }
  };

  // 햄버거 버튼을 숨겨야 하는 경우 null 반환
  if (shouldHideBurgerMenu) {
    return null;
  }

  return (
    <div className="toggle-icon-wrapper">
      <Button
        variant="link"
        className="navbar-toggler-humburger-icon navbar-vertical-toggle"
        disabled={!checkorg}
        onClick={handleClick}
      >
        <span className="navbar-toggle-icon">
          <span className="toggle-line" />
        </span>
      </Button>
    </div>
  );
};

export default ToggleButton;
